import { Service } from '../mainService'
import { FiltrosProrrogacoes } from '@/types/administracao/filtros-prorrogacoes'
import { Prorrogacoes } from '@/types/administracao/prorrogacoes';

const prorrogacaoService = {
    buscarTiposProrrogacao,
    buscarProrrogacoes,
    removerProrrogacoes,
    alterarProrrogacao,
    adicionarProrrogacao,
    getProrrogacaoByID,
    buscarTiposRelatoriosLRF,
    buscarPeriodosRelatoriosLRF
}

async function buscarTiposProrrogacao() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/prorrogacao/tiposProrrogacao"); //VUE_APP_PRAZOS_PRORROGACAO
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function getProrrogacaoByID(id: string) {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/prorrogacao/prorrogacaoById/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function removerProrrogacoes(id: number) {
    try {
        const response = Service.$http.delete(process.env.VUE_APP_USERS_API + "/prorrogacao/excluirProrrogacao/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarProrrogacao(prorrogacao: Prorrogacoes) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/prorrogacao/adicionarProrrogacao", prorrogacao.toFormData());
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function alterarProrrogacao(prorrogacao: Prorrogacoes) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/prorrogacao/alterarProrrogacao", prorrogacao.toFormData());
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarProrrogacoes(filtros: FiltrosProrrogacoes) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/prorrogacao/consultarProrrogacoes", filtros.toFormData());
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarTiposRelatoriosLRF() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimentoLRF/tiposRelatorioLRF");
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarPeriodosRelatoriosLRF() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/vencimentoLRF/periodosLRF");
        return response;
    } catch (e: any) {
        return e.response;
    }
}

export default prorrogacaoService;